import React from 'react';
import { NavLink } from 'react-router-dom';
import { Card, Dropdown } from '@digdir/designsystemet-react';

import styled from '../../../styled';

const SideMenu = styled(Card)`
  justify-content: start;
  display: flex;
  flex-direction: column;
  border-radius: var(--ds-border-radius-md);
  padding: var(--ds-size-4);
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MenuItem = styled(({ isActive, ...props }) => <Dropdown.Button {...props} />)<{
  isActive?: boolean;
}>`
  font-weight: 500;
  width: 100%;
  flex-grow: 1;
  text-align: left;
  justify-content: flex-start;
  border-radius: var(--ds-border-radius-sm);
  background-color: ${({ theme, isActive }) => (isActive ? theme.palette.greys.grey2 : '')};

  :hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

const StyledNavLink = styled(NavLink)`
  color: black;
  text-decoration: none;
  padding: 0;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MenuItemSpan = styled(({ isActive, ...props }) => <span {...props} />)<{ isActive?: boolean }>`
  display: block;
  width: 100%;
  background: ${({ isActive }) => (isActive ? 'var(--ds-color-surface-active)' : 'transparent')};
  border-radius: var(--ds-border-radius-sm);
  padding: var(--ds-size-2) var(--ds-size-4);
  font-weight: ${({ isActive }) => (isActive ? 500 : 400)};
  text-wrap: wrap;
  color: var(--ds-color-text-default);

  :hover {
    background: ${({ isActive }) => (isActive ? 'var(--ds-color-surface-active)' : 'var(--ds-color-surface-hover)')};
  }
`;

export { MenuItem, MenuItemSpan, SideMenu, StyledNavLink };
